import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer p-3">
      <a href="https://github.com/dakotafabro/shecodes-dictionary-app">
        Open-Source Code
      </a>{" "}
      by <a href="https://dakotafabro.netlify.app/">Dakota Fabro</a> hosted on{" "}
      <a href="https://www.netlify.com/">Netlify</a>
    </div>
  );
}
